/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectM11ResearchStudyFoi, selectM11ReportContainerFoi, selectM11ReportContainerResource } from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import { forwardRef, useCallback, useState } from "react";
import { Buffer } from 'buffer';
import ViewPdf from "../../components/ViewPdfLauncher";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice";
import axiosInstance from "../../functions/axiosInstance";
import server_config from "../../ServerConfiguration";
import { useNavigate } from "react-router-dom";

const computable_publishing_node_server_address = server_config["computable_publishing_node_server_address"];

const handleDownload = (pdfData, fileName = "Sample", ext = ".pdf") => {
  const linkSource = `data:application/pdf;base64,${pdfData}`;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName + ext;
  downloadLink.click();
};

const getTheM11PDF = async (dispatch, apiToken, pdfState, setPdfState, docxState, setDocxState, setAlertModalState, download = false, pdfFileName = null, foi = undefined, saveDocx = false) => {
  if ((!pdfState && !saveDocx) || (!docxState && saveDocx)) {
    try {
      dispatch(globalLoadingOn());
      return await axiosInstance({
        method: 'POST',
        url: computable_publishing_node_server_address,
        timeout: 120000,
        data: {
          "functionid": "m11reporttopdf",
          "apiToken": apiToken,
          "foi": foi,
          "libraryfunction": "axios",
          "saveDocx": saveDocx
        },
      }).then(async (resp) => {
        if (resp?.data?.success) {
          if (resp.data.pdf?.data) {
            let pdfData = Buffer.from(resp.data.pdf.data).toString("base64");
            setPdfState(pdfData);
            if (download && pdfData) {
              handleDownload(pdfData, pdfFileName, ".pdf");
            }
            return pdfData;
          } else if (resp.data.docx?.data) {
            let docxData = Buffer.from(resp.data.docx.data).toString("base64");
            setDocxState(docxData);
            if (download && docxData) {
              handleDownload(docxData, pdfFileName, ".docx");
            }
            return docxData;
          }
        } else if (resp?.data?.error) {
          //alert(resp.data.error);
          setAlertModalState(prevState => {
            return {
              ...prevState,
              "open": true,
              "header": "Error",
              "content": resp.data.error
            };
          });
        }
        //return resp.data;
      }).catch(async (error) => { console.log(error); });
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(globalLoadingOff());
    }
  } else if (download) {
    if (saveDocx) {
      handleDownload(pdfState, pdfFileName, ".docx");
    } else {
      handleDownload(pdfState, pdfFileName, ".docx");
    }
  }
  return pdfState;
}

// eslint-disable-next-line no-empty-pattern
const M11ReportPdfViewer = forwardRef(({ setAlertModalState }, ref) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);

  const [pdfState, setPdfState] = useState();
  const [docxState, setDocxState] = useState();

  let pdfFileName = m11ReportContainerResource.id + " - " + (m11ReportContainerResource.title ? m11ReportContainerResource.title.substring(0, 60) : "Unnamed");

  const handleViewPdf = useCallback(() => {
    getTheM11PDF(dispatch, apiToken, pdfState, setPdfState, docxState, setDocxState, setAlertModalState, false, null, m11ReportContainerFoi, false);
  }, [apiToken, dispatch, pdfState, setPdfState]);

  return <div className="unselectable">
    <br />
    <ViewPdf label="View PDF" pdfData={pdfState} onLoad={handleViewPdf} />
    <button type="button" style={{ marginLeft: "12px" }}
      onClick={() => { getTheM11PDF(dispatch, apiToken, pdfState, setPdfState, docxState, setDocxState, setAlertModalState, true, pdfFileName, m11ReportContainerFoi, false); }}
    >{"Download PDF"}</button>
    <button type="button" style={{ marginLeft: "12px" }}
      onClick={() => { getTheM11PDF(dispatch, apiToken, pdfState, setPdfState, docxState, setDocxState, setAlertModalState, true, pdfFileName, m11ReportContainerFoi, true); }}
    >{"Download DOCX"}</button>
    <br />    <br />
    <button type="button" style={{ marginLeft: "12px" }}
      onClick={() => { navigate("/" + m11ReportContainerFoi); }}
    >{"View FHIR Composition"}</button>
    <button type="button" style={{ marginLeft: "12px" }}
      onClick={() => { navigate("/" + m11ReportContainerFoi + "#json"); }}
    >{"Download FHIR Bundle"}</button>
  </div>;
});

// eslint-disable-next-line no-empty-pattern
const M11Step045CreateM11Report = ({ setAlertModalState }) => {
  const theM11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);
  return <div>
    <h3>Generate the M11 Report</h3>
    <M11ReportPdfViewer setAlertModalState={setAlertModalState} />
    <br />
    <br />
    View the <a href={"/" + theM11ResearchStudyFoi} target="_blank" rel="noopener noreferrer">M11ResearchStudy for FOI {theM11ResearchStudyFoi}</a>
  </div>
};

const M11Step045CreateM11ReportHelperText = <div>
  <h3>Generate the M11 Report</h3>
  <div style={{ textAlign: "left" }}>
    <p>Click View M11 Report PDF to view it.</p>
    <p>Click Download M11 Report PDF to download it.</p>
  </div>
</div>

export default M11Step045CreateM11Report;
export { M11Step045CreateM11ReportHelperText, getTheM11PDF };